import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import AppointmentBooking, { AppointmentBookingProps } from 'APP/Components/AppointmentBooking'
import { NativeStackScreenProps } from '@react-navigation/native-stack'

export type AppointmentBookingScreenRouteProp = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'appointmentBookingScreen'
>

export const ContentContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1
  background-color: ${({ theme }) => theme.colors.background};
`

const AppointmentBookingScreen = ({ route, navigation }: AppointmentBookingScreenRouteProp) => {
  const onClose = () => {
    navigation.goBack()
  }

  const props = {
    post: route.params.post, // TODO: Remove need for post at the root
    sendAnswer: route.params.sendAnswer,
    ...route.params.post?.props,
    close: onClose,
  } as AppointmentBookingProps

  return (
    <ContentContainer>
      <AppointmentBooking {...props} />
    </ContentContainer>
  )
}

export default AppointmentBookingScreen
